import { Component } from '@angular/core';
import { PuserserviceService } from "./services/puserservice.service";
import { UserService } from "./services/user.service";
import { ExchangeService } from "./services/exchange.service";
import { ReportService } from "./services/report.service";
import { AdminService } from "./services/admin.service";
import { Router  } from '@angular/router';
import { NotificationsService } from "angular2-notifications";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app';
    menulist = [];
    menulists = [];
    submenlist = [];
    constructor(
        private userService: UserService,
        private exchangeService: ExchangeService,
        private reportService: ReportService,
        private adminService: AdminService,
        private router:Router,
        private  notifSer: NotificationsService,
        private spinner:Ng4LoadingSpinnerService,
        ) {

        if (this.userService.isLoggedIn()) {

            this.getMenu();
            this.adminService.groupupdate.subscribe(currency => {
                this.getMenu();
            })
        }
    }
    menulistarr:any = [];
    admindetails:any;
    userid:any;
    ngOnInit() {
        var routername = this.router.url;
        routername = routername.replace('/', '');
        this.admindetails = this.userService.getUserDetails();
        if (this.userService.isLoggedIn()) {
        this.adminService.getAdminPanelMenus().subscribe((success) => {
            this.menulist = success.menu;
            this.menulists = [];
            this.submenlist = success.submenu;    
            if(this.menulist){
                for (let index = 0; index < this.menulist.length; index++) {
                    this.menulistarr.push(this.menulist[index])
                }
            }        
            if(this.submenlist){
                Object.keys(this.submenlist).forEach(key => {
                    for (let index = 0; index < this.submenlist[key].length; index++) {
                        this.menulistarr.push(this.submenlist[key][index])                        
                    }
                });
            }
                var chk  = this.menulistarr.findIndex(x => (x.menu_url) !== routername);
                if(routername == 'home'){
                    this.router.navigate(["/home"]);
                }else if(chk !== -1 && this.admindetails.group !== 'super-admin') {
                            this.spinner.show();
                            this.router.navigate([".."]);
                            this.spinner.hide();
                                this.notifSer.error(
                                    'Error',
                                    'You are not get access from that page',
                                    {
                                        timeOut: 3000,
                                        showProgressBar: true,
                                        pauseOnHover: false,
                                        clickToClose: true,
                                        maxLength: 50
                                    }
                                )
                    }else{
                    }
        })
    }
    }

    getMenu() {
        this.adminService.getAdminPanelMenus().subscribe((success) => {
            var menulist = success.menu;
            if(menulist !== undefined){
                localStorage.setItem('permission', menulist[0].permission);
            }
        })
    }
    changeTradePrice(data) {
        this.reportService.toggleTradeChangePrice(data);
    }
    newOrderNotification() {
        this.exchangeService.toggleNewOrderNotification();
    }
    freezedOrderNotification() {
        this.exchangeService.toggleNewOrderNotification();
    }

    completeOrderNotification() {
        this.exchangeService.toggleCompleteOrderNotification();
    }
    walletUpdate() {
        this.exchangeService.toggleWalletUpdate();
    }
    admingroups(data) {
        this.adminService.toggleGroupUpdate(data);
    }
    getCurrencyNotificaion() {
        this.exchangeService.toggleUserCurrency()
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts